import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryBubbleComponent } from './category-bubble.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule, QaLocatorsModule, DefaultImageModule, LazyLoadImageModule],
  declarations: [CategoryBubbleComponent],
  exports: [CategoryBubbleComponent],
})
export class CategoryBubbleModule {}
